export default "__VITE_ASSET__kdORGXo4__"